import { mapTwoWayState } from 'schepotin-vuex-helpers';

export default {
    computed: {
        ...mapTwoWayState({
            namespace: 'menu',
            prefix: true,
        }, [
            'settings',
            'communication',
            'sourceCode',
            'online',
            'help',
            'toggledSidebar',
            'appVersion',
        ]),
        menuRightBarIsOpen() {
            return this.menuSettings
                || this.menuCommunication
                || this.menuSourceCode
                || this.menuOnline
                || this.menuHelp;
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/menu.js